// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetDataItemPagedListRequestViewModel from '../../viewModel/request/LearnitDataItems/GetDataItemPagedListRequestViewModel';
import DataItemResourceViewModel from '../../viewModel/resource/DataItemResourceViewModel';
import DataItemListResourcePagingResultViewModel from '../../viewModel/resource/DataItemListResourcePagingResultViewModel';
import LearnitTagResourceListResultViewModel from '../../viewModel/resource/LearnitTagResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getDataItemById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-data-item-by-id'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new DataItemResourceViewModel().fromDTO(dto);
  },
  /**  */
  async updateDataItem(id: number, model: DataItemResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-data-item'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.put<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async deleteDataItem(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-data-item'] ?? 'Learnit/DataItems/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async getDataItemPagedList(request: GetDataItemPagedListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-data-item-paged-list'] ?? 'Learnit/DataItems';
    const response = await service.get<any>(endpointPath, {
      query: {
        categories: requestDTO.categories,
        tags: requestDTO.tags,
        contentType: requestDTO.contentType,
        isActive: requestDTO.isActive,
        isDeleted: requestDTO.isDeleted,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new DataItemListResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async createDataItem(model: DataItemResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-data-item'] ?? 'Learnit/DataItems';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async getTagsByDataItemId(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-tags-by-data-item-id'] ?? 'Learnit/DataItems/{id}/Tags';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new LearnitTagResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async addTagToDataItem(id: number, tagId: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-add-tag-to-data-item'] ?? 'Learnit/DataItems/{id}/AddTag/{tagId}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    endpointPath = endpointPath.replace(/\{tagId\}/g, `${tagId}`);
    const response = await service.post<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async removeTagFromDataItem(id: number, tagId: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-remove-tag-from-data-item'] ?? 'Learnit/DataItems/{id}/RemoveTag/{tagId}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    endpointPath = endpointPath.replace(/\{tagId\}/g, `${tagId}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
});
